import { IGeo } from '@cian/chats-api';
import * as React from 'react';

import { isPrimaryMetroRegion } from '../../AddressContainer/helpers';

export const useUnderground = (geo?: IGeo) => {
  const underground = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }
    if (geo.undergrounds && isPrimaryMetroRegion(geo)) {
      const offerUndergrounds = geo.undergrounds.concat().sort((a, b) => a.time - b.time);

      return offerUndergrounds.find(underground => underground.isDefault) || offerUndergrounds[0];
    }

    return undefined;
  }, [geo]);

  return underground;
};
